/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import logo from "./customer-airbnb.svg";
import Company from "./company";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      blockquote: "blockquote"
    }, props.components), {Header} = _components;
    if (!Header) _missingMdxReference("Header", true);
    return _jsxs(_Fragment, {
      children: [_jsxs("article", {
        children: [_jsx(Header, {}), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I’ve learned:"
          }), " The opportunity on climate is so vast that the key part is identifying how to keep moving the ball forward—breaking big ideas down into concrete next steps so we can take immediate actions that move us toward our goals."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My role:"
          }), " Leveraging existing structures, sustainability has long been part of Airbnb’s history, and remains an important focus for Hosts and guests around the world. My role was created to take our opportunity to the next level, for our company and in partnership with our global community."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I want others to know:"
          }), " Even small individual changes add up when applied to millions of people. When you enter the climate space, it’s easy to look around and say “it’s too big,” “it’s too late,” or “what can I really add.” It’s about our collective power, and that each of us doing our part can make a real difference."]
        })]
      }), "\n", _jsxs(Company, {
        name: "Airbnb",
        logo: logo,
        children: [_jsx(_components.p, {
          children: "A global community based on connection and belonging, where Hosts and guests can be catalysts for sustainable activity in their communities."
        }), _jsx(_components.p, {
          children: "Already matching 100% of corporate electricity with renewable energy and committed to a net-zero corporate footprint by 2030."
        })]
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["It’s not about adding ‘and what about sustainability’ as an afterthought; it’s about partnering to ", _jsx("mark", {
            children: "embed sustainability as a decision-making criteria"
          }), "."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
